export default __webpack_public_path__ + "static/media/c001-student-7.bed109bd.jpg";